import { createSlice } from '@reduxjs/toolkit'
import * as asyncActions from './account.asyncActions'

const initialState = {
	accountUsers: [],
	accountModal: null,
	accountUsersInfo: [],
	isAddUserModal: false,
	backOfficeAccounts: [],
	email: [],
	selectedRow: {},
	fflDetails: {},
	userManualFile: {},
	selectedAccount: {},
}

const slice = createSlice({
	name: 'account',
	initialState,
	reducers: {
		updateFilter(state, action) {
			state.filter = action.payload
		},
		setAccountModal(state, action) {
			state.accountModal = action.payload
		},
		setIsAddUserModal(state, action) {
			state.isAddUserModal = action.payload || initialState.isAddUserModal
		},
		resetAddUserModal(state, action) {
			state.isAddUserModal = initialState.isAddUserModal
		},
		setEmail(state, action) {
			state.email = action.payload
		},
		setSelectedRow(state, action) {
			state.selectedRow = action.payload || initialState.selectedRow
		},
		resetFFLDetails(state, action) {
			state.fflDetails = initialState.fflDetails
		},
		resetSelectedAccount(state, action) {
			state.selectedAccount = initialState.selectedAccount
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(asyncActions.fetchAccountUsers.fulfilled, (state, action) => {
				state.accountUsers = action.payload || initialState.accountUsers
			})
			.addCase(
				asyncActions.fetchBackOfficeAccounts.fulfilled,
				(state, action) => {
					state.backOfficeAccounts =
						action.payload || initialState.backOfficeAccounts
				}
			)
			.addCase(asyncActions.fetchFFLDetails.fulfilled, (state, action) => {
				state.fflDetails =
					(typeof action.payload !== 'string' && action.payload) ||
					initialState.fflDetails
			})
			.addCase(
				asyncActions.downloadUserManualFile.fulfilled,
				(state, action) => {
					state.userManualFile = action.payload || initialState.userManualFile
				}
			)
			.addCase(asyncActions.fetchAccountDetails.fulfilled, (state, action) => {
				state.selectedAccount = action.payload || initialState.selectedAccount
			})
	},
})

export default slice

export const { name, actions, reducer } = slice
